import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AuthService, Product,   GlobalMessageService,  GlobalMessageType,  TranslationService } from '@spartacus/core';
import {  CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { UigWishListService } from '../../uig-wish-list/uig-wish-list.service';
import {AddToWishListComponent} from '@spartacus/cart/wish-list/components/add-to-wishlist';
import {OrderEntry} from '@spartacus/cart/base/root';
import {WishListService} from '@spartacus/cart/wish-list/core';

@Component({
    selector: 'app-uig-add-to-wishlist',
    templateUrl: './uig-add-to-wishlist.component.html',
    styleUrls: ['./uig-add-to-wishlist.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigAddToWishlistComponent extends AddToWishListComponent {

  /**
   * The UigAddToWishlistComponent supports 2 types of styling:
   *   - One that includes the "HEART" and "EMPTY_HEART" icon types;
   *   - And one that only includes a simple checkbox with a label.
   * Use this flag to switch between the 2 types of styling.
   */
  @Input() public checkboxStyle?: boolean = false;
  @Input() public product?: Product;

  wishListEntries$: Observable<
  OrderEntry[]
> = this.uigWishListService.getWishList().pipe(
  filter((wishlist) => Boolean(wishlist)),
  map((wishList) => wishList.entries)
);

   constructor(
    protected wishListService: WishListService,
    protected currentProductService: CurrentProductService,
    protected authService: AuthService,
    protected uigWishListService: UigWishListService,
    protected translationService: TranslationService,
    protected messageService: GlobalMessageService
  ) {
    super(wishListService, currentProductService, authService);
  }

  public toggleProductInWishlist(event: Event, entry: OrderEntry, product: Product): void {
    if ((event.target as HTMLInputElement).checked) {
      this.add(product);
    } else {
      this.remove(entry);
    }
  }

  public isInStock(product: Product): boolean {
    return Boolean(product.stock && product.stock.stockLevelStatus !== 'outOfStock');
  }

  add(product: Product): void {
    this.uigWishListService.addEntry(product.code);
  }

  remove(entry: OrderEntry): void {
    this.uigWishListService.removeEntry(entry);
  }

  errorHandler(isListed: boolean, productCode: string): void {
    if (!isListed) {
      var element = document.getElementById('wishlist_' + productCode); 
      if (element != undefined) {
        (element as HTMLInputElement).checked = false;
      }

      var element = document.getElementById('wishlist_heart_' + productCode); 
      if (element != undefined) {
        (element as HTMLInputElement).type = "iconTypes.EMPTY_HEART";
      }

      this.translationService.translate('uigWishList.errors.notListed')
       .pipe(
        tap((text) => {
          this.messageService.add(text, GlobalMessageType.MSG_TYPE_WARNING);
        })
       )
       .subscribe();
    }
  }
}
